import { authConfig } from "../apiConfig";



export const get_leave_types_with_out_pagination = async () => {
  try {
    const response = await authConfig.post(`getLeaveTypes`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_leave_types_with_pagination = async (data) => {
  try {
    const response = await authConfig.post(`getLeaveTypes`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_leave_type_by_id = async (data) => {
  try {
    const response = await authConfig.post(`leaveTypeViewbyID`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const leave_type_creation = async (data) => {
  try {
    const response = await authConfig.post(`storeLeavetype`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const leave_type_update = async (data) => {
  try {
    const response = await authConfig.post(`updateLeavetype`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const leave_type_deletion = async (data) => {
  try {
    const response = await authConfig.post(`leaveTypeDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};